import type { IWorkspace } from '@platform/core/types';
import type { IVisitedWorkspace } from './IVisitedWorkspace';

/** Простори, де користувач учасник (без відкритих за посиланням чужих просторів — `visiting`): перемикач і «Ваші робочі простори». Чиста функція. */
export function memberWorkspaces<T extends IWorkspace>(workspaces: readonly T[]): T[] {
  return workspaces.filter((w) => !(w as IVisitedWorkspace).visiting);
}
